export default "__VITE_ASSET__BJfxXtPB__"